import Model from "../classes/Model";
import FiliationApi from "../classes/api/Filiation";
import ValidationError from "../classes/ValidationError";

export default class Filiation extends Model {

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get address() {
        return this._address;
    }
    set address(value) {
        this._address = value;
    }

    get id() {
        return this._id;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            name: this.name,
            address: this.address,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            name: data.name,
            address: data.address,
        };
    }

    static getList(page = 1, perPage = 10) {
        return FiliationApi.getList(page, perPage).then((response) => {
            let data = [];
            for (let filliation of response.data) {
                data.push(new this(this.toResponse(filliation)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return FiliationApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return FiliationApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new Filiation(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return FiliationApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}
